// Copyright (c) StrangeBee 2023

import { AdminPermissions, OrgPermissions, AllPermissions } from 'thehive-sdk';

interface UsePermissionsInterface {
    permissionsNeeded: AdminPermissions[] | OrgPermissions[] | AllPermissions[];
    permissionsList: AdminPermissions[] | OrgPermissions[];
}

const usePermissions = ({ permissionsNeeded = [], permissionsList }: UsePermissionsInterface): boolean =>
    (permissionsNeeded as string[]).every((permission) => (permissionsList as string[]).includes(permission));

export default usePermissions;
